import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import WalkingComponent from 'components/Walking/WalkingComponent';
import { useServiceCategoryAccess } from 'hooks';
import { Redirect } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

export const Walking: FunctionComponent<ServicesProps> = props => {
    const { isAllowed, redirectTo } = useServiceCategoryAccess('walking');
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('walking');

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Walking - Cuddles"
            pageName="/walking"
            pageSidebar={sidebar}
        >
            <WalkingComponent />
        </PrivatePage>
    );
};

export default Walking;
